import {Injectable} from '@angular/core';
import {HttpParams} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class CommonService {

  public handleError(error: any) {
    console.log('-------------');
    console.error(error);
    console.log('-------------');
    const errorResponse = error.error;
    // console.error('handleError', errorResponse);
    return {
      status: errorResponse._error ? errorResponse._error.errorCode : errorResponse.status,
      message: errorResponse._error ? errorResponse._error.detailMessage || errorResponse._error.message : errorResponse.message
    };

  }

  generateHttpParams(obj: any) {
    let params = new HttpParams();

    for (var propName in obj) {
      let propValue = obj[propName];
      if (propValue != undefined) {
        params = params.append(propName, propValue);
      }
    }
    return params;
  }

}
